"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = unregisterGlobalPlugins;
var exclude = ['filler', 'legend', 'title'];

function unregisterGlobalPlugins(ChartJS) {
  var plugins = ChartJS.plugins.getAll().filter(function (plugin) {
    return !exclude.includes(plugin.id);
  });
  ChartJS.plugins.unregister(plugins);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Chart/helpers/unregisterGlobalPlugins.js
// module id = 6MCO
// module chunks = 0